import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCurrentPage } from "../store/navSlice";
import { setActiveProcessStep, toggleFaq } from "../store/homeSlice";
import {
  Container,
  keyframes,
  Typography,
  Box,
  Button,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Modal,
  Fade,
  AppBar,
  Toolbar,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import CallEndIcon from "@mui/icons-material/CallEnd";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChatButton from "../components/freeChatComponent/ChatButton";
import { useLocation } from "react-router-dom";
import LogoImage from "../images/decodia-logo.png";
import Home_decodia from "../vedio/Home_decodia.mp4";
import newProject1 from "../images/newProject/newProject1.png";
import newProject2 from "../images/newProject/newProject2.jpg";
import newProject3 from "../images/newProject/newProject3.jpg";
import newProject4 from "../images/newProject/newProject4.jpg";
import newProject10 from "../images/newProject/newProject10.png";
import newProject11 from "../images/newProject/newProject11.png";
import newProject12 from "../images/newProject/newProject12.png";
import newProject14 from "../images/newProject/newProject14.png";
import newProject15 from "../images/newProject/newProject15.jpg";
import commercial1 from "../images/commercial/bedroom1 .png";
import commercial2 from "../images/commercial/bedroom10.png";
import commercial3 from "../images/commercial/bedroom11.png";
import commercial5 from "../images/commercial/bedroom2.png";
import commercial6 from "../images/commercial/bedroom3.jpg";
import renovation3 from "../images/renovation/renovation3.jpg";
import renovation4 from "../images/renovation/renovation4.jpg";
import renovation5 from "../images/renovation/renovation5.jpg";
import renovation6 from "../images/renovation/renovation6.jpg";
import renovation7 from "../images/renovation/renovation7.jpg";
import renovation8 from "../images/renovation/renovation8.jpg";
import renovation9 from "../images/renovation/renovation9.jpg";
import residential5 from "../images/residential/residential5.png";
import residential6 from "../images/residential/residential6.png";
import residential10 from "../images/residential/residential10.jpg";
import residential11 from "../images/residential/residential11.png";
import residential12 from "../images/residential/residential12.jpeg";
import residential13 from "../images/residential/residential13.jpg";
import "../css/Home.css";
import line_break from "../images/line_break.jpg";
import capabilities_2_x1 from "../images/capabilities_2_x1.webp";
import ConsultationFormDialog from "./Consultation"; 

// Clean, professional animation keyframes
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const shimmerAnimation = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;

const slideDown = keyframes`
  from { 
    opacity: 0;
    transform: translateY(-10px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
`;

const underline = keyframes`
  from { width: 0; }
  to { width: 100%; }
`;

const pulseAnimation = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
`;

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [openForm, setOpenForm] = useState(false);

  const { menuItems } = useSelector((state) => state.navigation);

  const [scrolled, setScrolled] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const currentPath = location.pathname;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavigation = (path, label) => {
    navigate(path);
    dispatch(setCurrentPage(label));
    setDrawerOpen(false);
  };

  const desktopMenu = (
    <Box
      sx={{
        display: "flex",
        gap: 4,
        alignItems: "center",
        animation: `${fadeIn} 0.6s ease-out`,
      }}
    >
      {menuItems.map((item, index) => (
        <Box
          key={item.id}
          sx={{
            animation: `${slideDown} 0.4s ease-out ${index * 0.05}s forwards`,
            opacity: 0,
          }}
        >
          <Button
            onClick={() => handleNavigation(item.path, item.label)}
            sx={{
              color: "white",
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.95rem",
              position: "relative",
              padding: "8px 12px",
              minWidth: "auto",
              borderRadius: "4px",
              transition: "all 0.3s ease",

              "&:hover": {
                color: "#EED688",
                background:
                  "linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(238, 214, 136, 0.1))",
                transform: "translateY(-2px)",

                // Underline animation on hover
                "&::after": {
                  content: '""',
                  position: "absolute",
                  width: "100%",
                  height: "2px",
                  bottom: "0",
                  left: "0",
                  background:
                    "linear-gradient(90deg, #FF6B35, #FF8E53, #EED688)",
                  animation: `${underline} 0.3s ease-out`,
                  borderRadius: "2px",
                },
              },

              // Active page styling
              ...(currentPath === item.path && {
                color: "#FF6B35",
                fontWeight: 700,
                background:
                  "linear-gradient(135deg, rgba(255, 107, 53, 0.15), rgba(255, 142, 83, 0.1))",

                "&::after": {
                  content: '""',
                  position: "absolute",
                  width: "100%",
                  height: "2px",
                  bottom: "0",
                  left: "0",
                  background:
                    "linear-gradient(90deg, #FF6B35, #FF8E53, #FF6B35)",
                  borderRadius: "2px",
                  animation: `${pulse} 2s infinite`,
                },
              }),
            }}
          >
            {item.label}
          </Button>
        </Box>
      ))}

      <Box
        sx={{
          animation: `${slideDown} 0.4s ease-out 0.3s forwards`,
          opacity: 0,
          ml: 1,
        }}
      >
        <Button
          variant="contained"
          onClick={() => setOpenForm(true)}
          sx={{
            background: "linear-gradient(45deg, #FF6B35 0%, #FF8E53 100%)",
            backgroundSize: "200% 200%",
            color: "white",
            fontWeight: 700,
            borderRadius: "8px",
            padding: "10px 24px",
            fontSize: "0.95rem",
            textTransform: "none",
            position: "relative",
            overflow: "hidden",
            animation: `${pulseAnimation} 3s infinite`,
            transition: "all 0.3s ease",

            "&:hover": {
              background: "linear-gradient(45deg, #E55A2B 0%, #FF7B42 100%)",
              transform: "translateY(-2px)",
              boxShadow: "0 8px 20px rgba(255, 107, 53, 0.3)",
              animation: `${pulseAnimation} 1.5s infinite`,

              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-100%",
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)",
                animation: `${shimmerAnimation} 1.5s ease-out`,
              },
            },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <ChatBubbleIcon sx={{ fontSize: 18 }} />
            Free Consultation
          </Box>
        </Button>

        <ConsultationFormDialog
          open={openForm}
          onClose={() => setOpenForm(false)}
        />
      </Box>
    </Box>
  );

  const mobileMenu = (
    <>
      <IconButton
        onClick={() => setDrawerOpen(true)}
        sx={{
          color: "white",
          animation: `${fadeIn} 0.5s ease-out`,
          transition: "transform 0.3s ease",

          "&:hover": {
            transform: "rotate(90deg)",
          },
        }}
      >
        <MenuIcon />
      </IconButton>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: 280,
            background: "linear-gradient(135deg, #0F0F0F 0%, #1a1a1a 100%)",
            color: "white",
            animation: `${fadeIn} 0.3s ease-out`,
          },
        }}
      >
        <Box sx={{ p: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <img
              src={LogoImage}
              alt="DECODIA"
              style={{ height: 50, width: "auto" }}
            />
            <IconButton
              onClick={() => setDrawerOpen(false)}
              sx={{
                color: "white",
                transition: "transform 0.3s ease",

                "&:hover": {
                  transform: "rotate(90deg)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <List>
            {menuItems.map((item, index) => (
              <ListItem
                key={item.id}
                button
                onClick={() => handleNavigation(item.path, item.label)}
                sx={{
                  py: 2,
                  mb: 1,
                  borderRadius: "4px",
                  backgroundColor:
                    currentPath === item.path
                      ? "rgba(255, 107, 53, 0.1)"
                      : "transparent",
                  animation: `${fadeIn} 0.3s ease-out ${index * 0.05}s forwards`,
                  opacity: 0,
                  transition: "all 0.3s ease",

                  "&:hover": {
                    backgroundColor: "rgba(255, 107, 53, 0.05)",
                    paddingLeft: "20px",
                  },
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontWeight: 600,
                    color: currentPath === item.path ? "#FF6B35" : "white",
                  }}
                />
              </ListItem>
            ))}
          </List>

          <Box sx={{ mt: 3, p: 2 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => setOpenForm(true)}
              sx={{
                background: "linear-gradient(45deg, #FF6B35 30%, #FF8E53 90%)",
                color: "white",
                fontWeight: 600,
                borderRadius: "8px",
                padding: "14px 24px",
                animation: `${pulseAnimation} 3s infinite`,
                transition: "all 0.3s ease",

                "&:hover": {
                  background:
                    "linear-gradient(45deg, #E55A2B 30%, #FF7B42 90%)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 15px rgba(255, 107, 53, 0.3)",
                  animation: `${pulseAnimation} 1.5s infinite`,
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                }}
              >
                <ChatBubbleIcon sx={{ fontSize: 18 }} />
                Free Consultation
              </Box>
            </Button>
          </Box>
        </Box>
      </Drawer>
         <ConsultationFormDialog
        open={openForm}
        onClose={() => setOpenForm(false)}
      />
    </>
  );

  return (
    <AppBar
      position="absolute"
      elevation={0}
      sx={{
        background: "transparent",
        backdropFilter: scrolled ? "blur(10px)" : "none",
        transition: "all 0.3s ease",
        borderBottom: scrolled ? "1px solid rgba(255,255,255,0.1)" : "none",
        animation: `${fadeIn} 0.6s ease-out`,
      }}
    >
      <Container maxWidth="1400px" sx={{ margin: 0, px: 0, py: 2 }}>
        <Toolbar
          sx={{
            minHeight: 70,
            justifyContent: "space-between",
            width: "100%",
            maxWidth: "1400px",
            margin: "0 auto",
          }}
        >
          <Box
            onClick={() => handleNavigation("/", "Home")}
            sx={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              transition: "transform 0.3s ease",

              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
          >
            <img
              src={LogoImage}
              alt="DECODIA"
              style={{ height: 60, width: "auto" }}
            />
          </Box>

          {!isMobile ? desktopMenu : mobileMenu}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openForm, setOpenForm] = useState(false);
  const videoRef = useRef(null);
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);

  const { hero, services, processSteps, faqs, cta, expandedFaqs } =
    useSelector((state) => state.home);

  const projectImages = [
    newProject1,
    newProject4,
    newProject10,
    newProject11,
    newProject12,
    newProject14,
    newProject15,
    commercial1,
    commercial2,
    commercial3,
    commercial5,
    commercial6,
    residential5,
    residential6,
    residential10,
    residential11,
    residential12,
    residential13,
    residential5,
    renovation3,
    renovation4,
    renovation5,
    renovation6,
    renovation7,
    renovation8,
    renovation9,
  ];

  useEffect(() => {
    dispatch(setCurrentPage("Home"));
    if (videoRef.current) {
      const playPromise = videoRef.current.play();

      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          videoRef.current.muted = true;
          videoRef.current.play();
        });
      }
    }
  }, [dispatch]);

  const handleFaqToggle = (faqId) => {
    dispatch(toggleFaq(faqId));
  };

  const handleProcessStepClick = (index) => {
    dispatch(setActiveProcessStep(index));
  };

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleServiceExplore = (service) => {
    const serviceName = service.title.toLowerCase();
    if (serviceName.includes("commercial")) {
      console.log("Navigating to Commercial gallery");
      navigate("/services", {
        state: {
          openCommercialGallery: true,
          serviceName: service.title,
          scrollBehavior: "smooth",
        },
      });
    } else if (serviceName.includes("renovation")) {
      console.log("Navigating to Renovation gallery");
      navigate("/services", {
        state: {
          openRenovationGallery: true,
          serviceName: service.title,
          scrollBehavior: "smooth",
        },
      });
    } else if (serviceName.includes("residential")) {
      console.log("Navigating to Residential gallery");
      navigate("/services", {
        state: {
          openResidentialGallery: true,
          serviceName: service.title,
          scrollBehavior: "smooth",
        },
      });
    } else if (
      serviceName.includes("new project") ||
      serviceName.includes("newproject") ||
      serviceName.includes("new construction")
    ) {
      console.log("Navigating to New Project gallery");
      navigate("/services", {
        state: {
          openNewProjectGallery: true,
          serviceName: service.title,
          scrollBehavior: "smooth",
        },
      });
    } else {
      // For other services, scroll to them as before
      console.log("Navigating to service:", service.id);
      navigate("/services", {
        state: {
          scrollToService: service.id,
          serviceName: service.title,
          scrollBehavior: "smooth",
        },
      });
    }
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === projectImages.length - 1 ? 0 : prevIndex + 1,
    );
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? projectImages.length - 1 : prevIndex - 1,
    );
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (lightboxOpen) {
        if (e.key === "ArrowRight") {
          handleNextImage();
        } else if (e.key === "ArrowLeft") {
          handlePrevImage();
        } else if (e.key === "Escape") {
          setLightboxOpen(false);
          setFullscreen(false);
        } else if (e.key === "f" || e.key === "F") {
          setFullscreen(!fullscreen);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [lightboxOpen, fullscreen]);

  const handleFullscreenToggle = () => {
    setFullscreen(!fullscreen);
  };

  return (
    <div className="home-container">
      <Navigation />
      <Drawer
        anchor="right"
        open={mobileMenuOpen}
        onClose={handleMobileMenuToggle}
        sx={{
          "& .MuiDrawer-paper": {
            width: 280,
            background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
          },
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#1D3557",
            }}
          >
            Menu
          </Typography>
          <IconButton onClick={handleMobileMenuToggle}>
            <CloseIcon />
          </IconButton>
        </Box>
        <List>
          {["ABOUT", "PRICES", "FOR BUSINESS", "BLOG", "CONTACT US"].map(
            (text) => (
              <ListItem
                button
                key={text}
                onClick={() => {
                  handleMobileMenuToggle();
                  navigate(`/${text.toLowerCase().replace(" ", "-")}`);
                }}
                sx={{
                  borderBottom: "1px solid rgba(0,0,0,0.05)",
                  "&:hover": {
                    background: "rgba(29, 53, 87, 0.05)",
                  },
                }}
              >
                <ListItemText
                  primary={text}
                  primaryTypographyProps={{
                    fontWeight: 600,
                    fontSize: "0.95rem",
                    color: "#5f6f85",
                  }}
                />
              </ListItem>
            ),
          )}
          <ListItem
            sx={{
              mt: 2,
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                handleMobileMenuToggle();
                navigate("/login");
              }}
              sx={{
                background: "linear-gradient(45deg, #1D3557 30%, #2b2b3a 90%)",
                borderRadius: "20px",
                fontWeight: 600,
              }}
            >
              Sign in
            </Button>
          </ListItem>
          <ListItem
            sx={{
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                color: "#008C9E",
                fontSize: "1.1rem",
                "&:before": {
                  content: '"°"',
                  position: "relative",
                  top: "-2px",
                  marginLeft: "2px",
                  fontSize: "0.8rem",
                  fontWeight: 800,
                },
              }}
            >
              360
            </Typography>
          </ListItem>
        </List>
      </Drawer>
      <Box
        className="hero-section"
        sx={{
          position: "relative",
          overflow: "hidden",
          minHeight: { xs: "100vh", md: "100vh" },
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
            "&::after": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 2,
              background:
                "linear-gradient(135deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.2) 100%)",
            },
          }}
        >
          <video
            ref={videoRef}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 1,
            }}
          >
            <source src={Home_decodia} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Box>
        <Container
          maxWidth="lg"
          className="hero-content"
          sx={{ position: "relative", zIndex: 3 }}
        >
          <Grid
            container
            spacing={4}
            sx={{
              textAlign: { xs: "center", md: "left" }, // Center on mobile, left on desktop
              alignItems: "center", // Center vertically
              justifyContent: "space-between",
              margin: 0,
              padding: 0,
            }}
          >
            {/* Left Column - Content */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                height: "100%",
                margin: 0,
                padding: 0,
              }}
            >
              <Stack spacing={3}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: {
                      xs: "1.4rem",
                      sm: "1.5rem",
                      md: "1.5rem",
                      lg: "2.3rem",
                    },
                    color: "white",
                    textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                    fontWeight: 600,
                    lineHeight: 1.6,
                    pt: 8,
                    pb: 0,
                    px: 0,
                    m: 0,
                    textTransform: "uppercase",
                  }}
                >
                  {hero?.title}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: {
                      xs: "1.0rem",
                      sm: "1.1rem",
                      md: "1.2rem",
                      lg: "1.2rem",
                    },
                    color: "rgba(255,255,255,0.9)",
                    lineHeight: 1.6,
                    m: 0,
                    py: 0,
                    fontWeight: 400, // Changed from default 600 (h6 default) to 400
                  }}
                >
                  {hero?.subtitle}
                </Typography>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  sx={{ mb: 4 }}
                >
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => setOpenForm(true)}
                    endIcon={<ArrowForwardIcon />}
                    className="cta-button-primary"
                    sx={{
                      px: { xs: 3, sm: 4 },
                      py: { xs: 1.25, sm: 1.5 },
                      fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
                      background:
                        "linear-gradient(45deg, #FF6B35 30%, #FF8E53 90%)",
                      color: "white",
                      fontWeight: 700,
                      borderRadius: "12px",
                      "&:hover": {
                        background:
                          "linear-gradient(45deg, #E55A2B 30%, #FF7B42 90%)",
                        transform: "translateY(-2px)",
                      },
                      transition: "all 0.3s ease",
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    Book Free Consultation
                  </Button>
                </Stack>

                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    mt: 2,
                    flexWrap: "wrap",
                    justifyContent: { xs: "center", md: "flex-start" },
                  }}
                >
                  {hero?.highlights?.map((highlight, index) => (
                    <Box
                      className="stat-badge"
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        padding: "6px 12px",
                        color: "white",
                        borderRadius: "20px",
                      }}
                    >
                      {highlight.icon}
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        color="white"
                        sx={{ fontSize: "0.875rem", fontWeight: 400 }}
                      >
                        {highlight.text}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box className="services-section">
        <Container maxWidth="xl">
          <Box sx={{ textAlign: "center", mb: { xs: 4, sm: 6, md: 8 } }}>
            <Typography
              className="section-title"
              variant="h2"
              sx={{
                fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
                margin: "0px",
                padding: "0px",
              }}
            >
              Our Design Services
            </Typography>
            <Typography
              className="section-subtitle"
              variant="h6"
              color="text.secondary"
              sx={{
                maxWidth: 700,
                mx: "auto",
                fontSize: { xs: "1rem", sm: "1.25rem" },
                textAlign: "center",
                px: 0,
                py: "0px",
              }}
            >
              Comprehensive design solutions tailored to your needs
            </Typography>
          </Box>

          {/* UPDATED: Changed to grid layout for better mobile responsiveness */}
          <Box
            className="services-container"
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr", // Single column on mobile
                sm: "repeat(2, 1fr)", // 2 columns on tablet
                md: "repeat(3, 1fr)", // 3 columns on medium
                lg: "repeat(4, 1fr)", // 4 columns on large
              },
              gap: { xs: 3, sm: 2, md: 3 }, // Consistent gaps
              width: "100%",
            }}
          >
            {services?.map((service, index) => (
              <Box
                className="service-card-wrapper"
                key={service.id}
                sx={{
                  width: "100%", // Full width within grid cell
                }}
              >
                <Card
                  className="service-card"
                  sx={{
                    height: "100%",
                    borderRadius: 2,
                  }}
                >
                  <Box className="service-image">
                    <CardMedia
                      component="img"
                      image={service.image}
                      alt={service.title}
                      sx={{
                        height: { xs: 180, sm: 150, md: 160 },
                        width: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <Box
                      className="service-icon"
                      sx={{
                        transform: "scale(0.8)",
                        "& svg": {
                          fontSize: { xs: "1.5rem", sm: "1.75rem" },
                        },
                      }}
                    >
                      {service.icon}
                    </Box>
                  </Box>
                  <CardContent
                    className="service-content"
                    sx={{ p: { xs: 2, sm: 2 } }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      gutterBottom
                      sx={{
                        fontSize: {
                          xs: "1rem",
                          sm: "0.9375rem",
                          md: "1rem",
                        },
                        mb: 1,
                      }}
                    >
                      {service.title}
                    </Typography>
                    <Typography
                      color="text.secondary"
                      paragraph
                      sx={{
                        mb: 1.5,
                        fontSize: { xs: "0.875rem", sm: "0.8125rem" },
                        lineHeight: { xs: 1.5, sm: 1.5 },
                      }}
                    >
                      {service.description}
                    </Typography>
                    <Box className="service-features" sx={{ mb: 1.5 }}>
                      {service.features?.map((feature, idx) => (
                        <Chip
                          key={idx}
                          className="feature-chip"
                          label={feature}
                          size="small"
                          sx={{
                            background: `rgba(${service.color}, 0.1)`,
                            color: service.color,
                            fontWeight: 500,
                            fontSize: { xs: "0.7rem", sm: "0.65rem" },
                            mr: 0.5,
                            mb: 0.5,
                            height: { xs: 24, sm: 22 },
                            px: 1,
                          }}
                        />
                      ))}
                    </Box>
                    <Button
                      fullWidth
                      variant="outlined"
                      endIcon={
                        <ArrowRightAltIcon
                          sx={{
                            fontSize: { xs: "0.875rem", sm: "1rem" },
                            color: "#E55A2B",
                          }}
                        />
                      }
                      sx={{
                        color: "white",
                        background:
                          "linear-gradient(45deg, #E55A2B 30%, #FF7B42 90%)",
                        borderColor: `rgba(${service.color}, 0.3)`,
                        fontWeight: 600,
                        borderRadius: "12px",
                        fontSize: { xs: "0.875rem", sm: "0.8125rem" },
                        py: { xs: 0.75, sm: 0.5 },
                        minHeight: { xs: 40, sm: 36 },
                        "&:hover": {
                          borderColor: service.color,
                          background: `rgba(${service.color}, 0.05)`,
                        },
                      }}
                      onClick={() => handleServiceExplore(service)}
                    >
                      Explore
                    </Button>
                  </CardContent>
                </Card>
              </Box>
            ))}
          </Box>
        </Container>
      </Box>

      {/* Process Steps Section */}
      <Box className="process-section">
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: { xs: 4, sm: 6 } }}>
            <Typography
              className="section-title"
              variant="h2"
              sx={{
                fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
                margin: "0px",
                padding: "0px",
              }}
            >
              Our 5-Step Process
            </Typography>
            <Typography
              className="section-subtitle"
              variant="h6"
              color="text.secondary"
              sx={{
                maxWidth: 700,
                mx: "auto",
                fontSize: { xs: "1rem", sm: "1.25rem" },
                px: 2,
              }}
            >
              A seamless journey from concept to completion
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {processSteps?.map((step, index) => (
              <Grid item xs={12} sm={6} md={4} lg={2.4} key={step.step}>
                <Box
                  className={`process-step ${step.active ? "active" : ""}`}
                  onClick={() => handleProcessStepClick(index)}
                >
                  <Box className="step-number">{step.step}</Box>
                  <Typography
                    className="step-title"
                    variant="h6"
                    fontWeight={700}
                    gutterBottom
                    sx={{
                      fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
                    }}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    className="step-description"
                    variant="body2"
                    sx={{
                      fontSize: { xs: "0.875rem", sm: "0.9rem" },
                    }}
                  >
                    {step.description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      <Box
        sx={{
          py: { xs: 8, md: 12 },
          bgcolor: "#b77446",
          position: "relative",
          color: "white",
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              textAlign: "center",
              mb: { xs: 6, sm: 8, md: 10 },
              px: { xs: 2, sm: 0 },
            }}
          >
            <Typography
              className="section-title"
              variant="h2"
              sx={{
                fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
                fontWeight: 600,
                margin: "0px",
                px: 0,
                pt: 0,
                pb: 1,
              }}
            >
              OUR INTERIOR DESIGN PROCESS
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "white",
                fontWeight: 600,
                fontSize: { xs: "0.95rem", sm: "1rem", md: "1.1rem" },
                fontStyle: "italic",
              }}
            >
              A structured approach where ideas turn into well-planned spaces.
            </Typography>
          </Box>

          {/* Feature 1 - Always text first, image second */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              mb: { xs: 8, md: 12 },
              gap: { xs: 4, md: 8 },
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                textAlign: { xs: "center", md: "left" },
                order: { xs: 1, md: 1 }, // Always first on mobile, first on desktop
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  color: "white",
                  fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.5rem" },
                  lineHeight: 1.2,
                }}
              >
                Detailed 2D Space Planning
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "white",
                  mb: 2,
                  lineHeight: 1.6,
                  fontSize: { xs: "0.875rem", sm: "0.95rem", md: "1rem" },
                }}
              >
                At this stage, we focus on understanding the structure, flow,
                and functionality of the space. Using detailed 2D layout plans,
                we define room proportions, wall placements, circulation paths,
                and spatial relationships. This helps us evaluate multiple
                layout possibilities, resolve space constraints early, and
                ensure every square foot is utilised efficiently before moving
                into design detailing.
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "white",
                  fontWeight: 600,
                  fontSize: { xs: "0.8rem", sm: "0.875rem", md: "0.95rem" },
                  fontStyle: "italic",
                }}
              >
                Strong interiors start with intelligent planning.
              </Typography>
            </Box>
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                flexShrink: 0,
                order: { xs: 2, md: 2 }, // Always second on mobile, second on desktop
              }}
            >
              <Box
                sx={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  height: { xs: 250, sm: 350, md: 400 },
                }}
              >
                <img
                  src={line_break}
                  alt="Draw a 2D plan of the apartment"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            </Box>
          </Box>

          {/* Feature 2 - Always text first, image second on mobile */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              mb: { xs: 8, md: 12 },
              gap: { xs: 4, md: 8 },
            }}
          >
            {/* Text Container - Always first on mobile */}
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                textAlign: { xs: "center", md: "right" },
                order: { xs: 1, md: 2 }, // First on mobile, second on desktop
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  color: "white",
                  fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.5rem" },
                  lineHeight: 1.2,
                }}
              >
                Translating Concepts into 3D Visualisation
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "white",
                  mb: 2,
                  lineHeight: 1.6,
                  fontSize: { xs: "0.875rem", sm: "0.95rem", md: "1rem" },
                }}
              >
                Once the layout is finalised, we convert the 2D plan into
                detailed 3D visualisations. This allows you to understand how
                the design will look and feel in real life — including scale,
                material combinations, colour palettes, and lighting intent.
                This stage bridges the gap between imagination and reality,
                helping you make confident design decisions
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "white",
                  fontWeight: 600,
                  fontSize: { xs: "0.95rem", sm: "1rem", md: "1.1rem" },
                  fontStyle: "italic",
                }}
              >
                Design clarity begins when ideas take form.
              </Typography>
            </Box>

            {/* Image Container - Always second on mobile */}
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                flexShrink: 0,
                order: { xs: 2, md: 1 }, // Second on mobile, first on desktop
              }}
            >
              <Box
                sx={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  height: { xs: 250, sm: 350, md: 400 },
                }}
              >
                <img
                  src={capabilities_2_x1}
                  alt="Create 3D visualizations and walkthroughs"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            </Box>
          </Box>

          {/* Feature 3 - Always text first, image second */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              mb: { xs: 8, md: 12 },
              gap: { xs: 4, md: 8 },
            }}
          >
            {/* Text Container (Left) */}
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                textAlign: { xs: "center", md: "left" },
                order: { xs: 1, md: 1 }, // Always first on mobile, first on desktop
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  color: "white",
                  fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.5rem" },
                  lineHeight: 1.2,
                }}
              >
                Furniture Planning & Material Coordination
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "white",
                  mb: 2,
                  lineHeight: 1.6,
                  fontSize: { xs: "0.875rem", sm: "0.95rem", md: "1rem" },
                }}
              >
                Through immersive 3D views and walkthroughs, we help you explore
                your interiors from different perspectives. This provides a
                realistic sense of space, movement, and depth, ensuring that
                design elements feel cohesive and balanced. It also allows us to
                fine-tune details early, reducing on-site changes during
                execution.
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "white",
                  fontWeight: 600,
                  fontSize: { xs: "0.95rem", sm: "1rem", md: "1.1rem" },
                  fontStyle: "italic",
                }}
              >
                Experience your space before it is built.
              </Typography>
            </Box>

            {/* Image Container (Right) */}
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                flexShrink: 0,
                order: { xs: 2, md: 2 }, // Always second on mobile, second on desktop
              }}
            >
              <Box
                sx={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  height: { xs: 250, sm: 350, md: 400 },
                }}
              >
                <img
                  src={newProject1}
                  alt="Furnish with realistic 3D objects"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            </Box>
          </Box>

          {/* Feature 4 - Always text first, image second on mobile */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              mb: { xs: 8, md: 12 },
              gap: { xs: 4, md: 8 },
            }}
          >
            {/* Image Container - Always second on mobile */}
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                flexShrink: 0,
                order: { xs: 2, md: 1 }, // Second on mobile, first on desktop
              }}
            >
              <Box
                sx={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  height: { xs: 250, sm: 350, md: 400 },
                }}
              >
                <img
                  src={newProject2}
                  alt="Draw on top of the blueprint"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            </Box>

            {/* Text Container - Always first on mobile */}
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                textAlign: { xs: "center", md: "left" },
                order: { xs: 1, md: 2 }, // First on mobile, second on desktop
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  color: "white",
                  fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.5rem" },
                  lineHeight: 1.2,
                }}
              >
                Designing Over Existing Blueprints
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "white",
                  mb: 2,
                  lineHeight: 1.6,
                  fontSize: { xs: "0.875rem", sm: "0.95rem", md: "1rem" },
                }}
              >
                For renovation and remodelling projects, we work directly on
                existing blueprints or floor plans. This approach helps us
                respect structural constraints while improving layout efficiency
                and visual flow. It allows us to transform existing spaces
                thoughtfully — without unnecessary structural changes.
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "white",
                  fontWeight: 600,
                  fontSize: { xs: "0.95rem", sm: "1rem", md: "1.1rem" },
                  fontStyle: "italic",
                }}
              >
                Reimagining spaces with clarity and precision.
              </Typography>
            </Box>
          </Box>

          {/* Feature 5 - Always text first, image second */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              mb: { xs: 8, md: 12 },
              gap: { xs: 4, md: 8 },
            }}
          >
            {/* Text Container (Left) */}
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                textAlign: { xs: "center", md: "left" },
                order: { xs: 1, md: 1 }, // Always first on mobile, first on desktop
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  color: "white",
                  fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.5rem" },
                  lineHeight: 1.2,
                }}
              >
                Doors, Windows & Architectural Detailing
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "white",
                  mb: 2,
                  lineHeight: 1.6,
                  fontSize: { xs: "0.875rem", sm: "0.95rem", md: "1rem" },
                }}
              >
                Doors, windows, and architectural elements are planned to
                enhance natural light, ventilation, and spatial rhythm. We
                customise sizes, placements, and finishes to align with the
                overall design concept, ensuring a seamless blend of
                functionality and architectural elegance.
              </Typography>
            </Box>

            {/* Image Container (Right) */}
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                flexShrink: 0,
                order: { xs: 2, md: 2 }, // Always second on mobile, second on desktop
              }}
            >
              <Box
                sx={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  height: { xs: 250, sm: 350, md: 400 },
                }}
              >
                <img
                  src={newProject3}
                  alt="Add windows and doors"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            </Box>
          </Box>

          <Typography
            variant="body2"
            sx={{
              color: "white",
              fontWeight: 600,
              fontSize: { xs: "0.95rem", sm: "1rem", md: "1.1rem" },
              fontStyle: "italic",
              textAlign: "center",
              mt: 4,
            }}
          >
            Our design process is structured, transparent, and intentional —
            ensuring every space is well-planned long before execution begins.
          </Typography>
        </Container>
      </Box>
      {/* Full Width Image Gallery Section */}
      <Box sx={{ py: { xs: 4, sm: 6, md: 0 }, bgcolor: "transparent" }}>
        {/* Thumbnail Grid */}

        {/* Main Image Display */}
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: { xs: "50vh", sm: "60vh", md: "80vh" },
            overflow: "hidden",
            cursor: "pointer",
            bgcolor: "black",
          }}
          onClick={() => setLightboxOpen(true)}
        >
          <img
            src={projectImages[currentImageIndex]}
            alt={`Project ${currentImageIndex + 1}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />

          {/* Navigation Buttons */}
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handlePrevImage();
            }}
            sx={{
              position: "absolute",
              left: { xs: 10, md: 20 },
              top: "50%",
              transform: "translateY(-50%)",
              bgcolor: "rgba(0,0,0,0.5)",
              color: "white",
              "&:hover": {
                bgcolor: "rgba(0,0,0,0.8)",
              },
            }}
          >
            <NavigateBeforeIcon fontSize="large" />
          </IconButton>

          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleNextImage();
            }}
            sx={{
              position: "absolute",
              right: { xs: 10, md: 20 },
              top: "50%",
              transform: "translateY(-50%)",
              bgcolor: "rgba(0,0,0,0.5)",
              color: "white",
              "&:hover": {
                bgcolor: "rgba(0,0,0,0.8)",
              },
            }}
          >
            <NavigateNextIcon fontSize="large" />
          </IconButton>

          {/* Image Counter */}
          <Box
            sx={{
              position: "absolute",
              bottom: { xs: 10, md: 20 },
              left: "50%",
              transform: "translateX(-50%)",
              bgcolor: "rgba(0,0,0,0.7)",
              color: "white",
              padding: "4px 12px",
              borderRadius: "20px",
              fontSize: { xs: "0.875rem", sm: "1rem" },
              fontWeight: 500,
            }}
          >
            {currentImageIndex + 1} / {projectImages.length}
          </Box>
        </Box>
      </Box>

      {/* Lightbox Modal */}
      <Modal
        open={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        closeAfterTransition
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Fade in={lightboxOpen}>
          <Box
            sx={{
              position: "relative",
              width: fullscreen ? "100vw" : { xs: "100%", md: "90vw" },
              height: fullscreen ? "100vh" : { xs: "80vh", md: "85vh" },
              bgcolor: "black",
              overflow: "hidden",
              outline: "none",
            }}
          >
            {/* Main Image */}
            <img
              src={projectImages[currentImageIndex]}
              alt={`Project ${currentImageIndex + 1}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />

            {/* Close Button */}
            <IconButton
              onClick={() => setLightboxOpen(false)}
              sx={{
                position: "absolute",
                top: { xs: 10, md: 20 },
                right: { xs: 10, md: 20 },
                bgcolor: "rgba(0,0,0,0.5)",
                color: "white",
                "&:hover": {
                  bgcolor: "rgba(0,0,0,0.8)",
                },
              }}
            >
              <CloseIcon fontSize="large" />
            </IconButton>

            <IconButton
              onClick={handleFullscreenToggle}
              sx={{
                position: "absolute",
                top: { xs: 10, md: 20 },
                right: { xs: 60, md: 80 },
                bgcolor: "rgba(0,0,0,0.5)",
                color: "white",
                "&:hover": {
                  bgcolor: "rgba(0,0,0,0.8)",
                },
              }}
            >
              {fullscreen ? (
                <FullscreenExitIcon fontSize="large" />
              ) : (
                <FullscreenIcon fontSize="large" />
              )}
            </IconButton>

            <IconButton
              onClick={handlePrevImage}
              sx={{
                position: "absolute",
                left: { xs: 10, md: 20 },
                top: "50%",
                transform: "translateY(-50%)",
                bgcolor: "rgba(0,0,0,0.5)",
                color: "white",
                "&:hover": {
                  bgcolor: "rgba(0,0,0,0.8)",
                },
              }}
            >
              <NavigateBeforeIcon fontSize="large" />
            </IconButton>

            <IconButton
              onClick={handleNextImage}
              sx={{
                position: "absolute",
                right: { xs: 10, md: 20 },
                top: "50%",
                transform: "translateY(-50%)",
                bgcolor: "rgba(0,0,0,0.5)",
                color: "white",
                "&:hover": {
                  bgcolor: "rgba(0,0,0,0.8)",
                },
              }}
            >
              <NavigateNextIcon fontSize="large" />
            </IconButton>
            <Box
              sx={{
                position: "absolute",
                bottom: { xs: 20, md: 30 },
                left: "50%",
                transform: "translateX(-50%)",
                bgcolor: "rgba(0,0,0,0.7)",
                color: "white",
                padding: "8px 16px",
                borderRadius: "20px",
                fontSize: { xs: "1rem", sm: "1.2rem" },
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography variant="body1">
                {currentImageIndex + 1} / {projectImages.length}
              </Typography>
            </Box>

            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                bgcolor: "rgba(0,0,0,0.7)",
                py: 2,
                px: { xs: 1, md: 2 },
                overflowX: "auto",
                display: "flex",
                gap: { xs: 1, md: 2 },
                justifyContent: "center",
                "&::-webkit-scrollbar": {
                  height: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "rgba(255,255,255,0.1)",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "rgba(255,107,53,0.5)",
                  borderRadius: "3px",
                },
              }}
            >
              {projectImages.map((image, index) => (
                <Box
                  key={index}
                  onClick={() => setCurrentImageIndex(index)}
                  sx={{
                    flexShrink: 0,
                    width: { xs: 60, md: 80 },
                    height: { xs: 60, md: 80 },
                    borderRadius: "4px",
                    overflow: "hidden",
                    cursor: "pointer",
                    border:
                      index === currentImageIndex
                        ? "3px solid #FF6B35"
                        : "3px solid transparent",
                    opacity: index === currentImageIndex ? 1 : 0.7,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      opacity: 1,
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  <img
                    src={image}
                    alt={`Thumbnail ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              ))}
            </Box>
          </Box>
        </Fade>
      </Modal>
      {/* FAQ Section */}
      <Box
        sx={{
          position: "relative",
          padding: { xs: "60px 0", md: "40px 0" },
          background: "white",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `linear-gradient(135deg, 
        rgba(255, 107, 53, 0.03) 0%, 
        rgba(0, 140, 158, 0.03) 25%, 
        rgba(29, 53, 87, 0.03) 50%, 
        rgba(105, 84, 36, 0.03) 75%, 
        rgba(198, 81, 38, 0.08) 100%)`,
            backgroundSize: "400% 400%",
            animation: "gradientShift 15s ease infinite",
            zIndex: 0,
          },
          "@media (max-width: 600px)": {
            padding: "48px 0",
          },
        }}
      >
        {[...Array(3)].map((_, i) => (
          <Box
            key={`shape-${i}`}
            sx={{
              position: "absolute",
              borderRadius: "50%",
              background: `linear-gradient(45deg, 
          rgba(${i === 0 ? "255, 107, 53" : i === 1 ? "0, 140, 158" : "29, 53, 87"}, 0.08), 
          rgba(${i === 0 ? "0, 140, 158" : i === 1 ? "105, 84, 36" : "255, 107, 53"}, 0.08))`,
              filter: "blur(40px)",
              animation: `float ${20 + i * 5}s ease-in-out infinite alternate`,
              animationDelay: `${i * 5}s`,
              pointerEvents: "none",
              zIndex: 0,
              display: { xs: "none", md: "block" },
              ...(i === 0 && {
                width: "300px",
                height: "300px",
                top: "-150px",
                left: "-150px",
              }),
              ...(i === 1 && {
                width: "200px",
                height: "200px",
                bottom: "-100px",
                right: "10%",
              }),
              ...(i === 2 && {
                width: "150px",
                height: "150px",
                top: "50%",
                right: "-75px",
              }),
            }}
          />
        ))}

        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
          <Box
            sx={{
              textAlign: "center",
              mb: { xs: 6, md: 8 },
              margin: 0,
              padding: 0,
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "2rem", sm: "2.8rem", md: "2.2rem" },
                fontWeight: 800,
                mb: 0,
                background: "linear-gradient(135deg, #2b2b3a 0%, #5f6f85 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                display: "inline-block",
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: "text.secondary",
                maxWidth: 700,
                mx: "auto",
                fontSize: { xs: "1rem", sm: "1.2rem" },
                fontWeight: 400,
                lineHeight: 1.6,
                mb: 1,
              }}
            >
              Find quick answers to common interior design inquiries
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                opacity: 0.7,
                maxWidth: 600,
                mx: "auto",
                my: 0,
                padding: 0,
                fontSize: { xs: "0.875rem", sm: "1rem" },
              }}
            >
              Can't find what you're looking for?{" "}
            </Typography>
          </Box>

          <Box
            sx={{
              background: "white",
              borderRadius: "24px",
              margin: 0,
              padding: { xs: "18px", sm: "20px", md: "30px" },
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.08)",
              position: "relative",
              overflow: "hidden",
              border: "1px solid rgba(224, 224, 224, 0.5)",
              "&:before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "4px",
                background: "linear-gradient(90deg, #FF6B35, #008C9E, #1D3557)",
                backgroundSize: "200% 100%",
                animation: "gradientShift 3s ease infinite",
              },
              "&:after": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "linear-gradient(45deg, rgba(255, 107, 53, 0.02), transparent)",
                opacity: 0,
                transition: "opacity 0.3s ease",
                pointerEvents: "none",
              },
              "&:hover:after": {
                opacity: 1,
              },
            }}
          >
            <Grid container spacing={4}>
              {[0, 1].map((colIndex) => {
                const totalFaqs = faqs?.length || 0;
                const itemsPerColumn = Math.ceil(totalFaqs / 2);
                const start = colIndex * itemsPerColumn;
                const end = Math.min(start + itemsPerColumn, totalFaqs);

                return (
                  <Grid item xs={12} md={6} key={colIndex}>
                    {faqs?.slice(start, end).map((faq) => (
                      <Box
                        key={faq.id}
                        sx={{
                          mb: 1,
                          padding: 0,
                          position: "relative",
                          "&:before": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            top: 0,
                            bottom: 0,
                            width: "3px",
                            background: expandedFaqs.includes(faq.id)
                              ? faq.color
                              : "transparent",
                            borderRadius: "2px",
                            transition: "all 0.3s ease",
                          },
                        }}
                      >
                        <Accordion
                          expanded={expandedFaqs.includes(faq.id)}
                          onChange={() => handleFaqToggle(faq.id)}
                          sx={{
                            background: "transparent",
                            boxShadow: "none",
                            margin: 0,
                            padding: 0,
                            borderRadius: "12px !important",
                            border: "1px solid rgba(104, 44, 44, 0.8)",
                            "&:before": { display: "none" },
                            "&.Mui-expanded": {
                              borderColor: faq.color,
                              background: `${faq.color}08`,
                              boxShadow: `0 5px 20px ${faq.color}20`,
                            },
                            "&:hover": {
                              borderColor: faq.color,
                              transform: "translateY(-2px)",
                              boxShadow: `0 8px 25px ${faq.color}15`,
                            },
                            transition: "all 0.3s ease",
                          }}
                        >
                          <AccordionSummary
                            sx={{
                              padding: {
                                xs: "12px 0",
                                sm: "16px 0",
                                md: "0px 0",
                              },
                              minHeight: "auto !important",
                              "&.Mui-expanded": {
                                borderBottom: "1px solid rgba(0,0,0,0.05)",
                              },
                              "&:hover": {
                                background: "transparent",
                              },
                            }}
                            expandIcon={
                              <Box
                                sx={{
                                  width: 28,
                                  height: 28,
                                  borderRadius: "8px",
                                  background: expandedFaqs.includes(faq.id)
                                    ? `${faq.color}15`
                                    : "rgba(0,0,0,0.05)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  transition: "all 0.3s ease",
                                }}
                              >
                                <ExpandMoreIcon
                                  sx={{
                                    fontSize: 20,
                                    color: expandedFaqs.includes(faq.id)
                                      ? faq.color
                                      : "#999",
                                    transform: expandedFaqs.includes(faq.id)
                                      ? "rotate(180deg)"
                                      : "rotate(0)",
                                    transition: "transform 0.3s ease",
                                  }}
                                />
                              </Box>
                            }
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: { xs: 2, sm: 3 },
                                flex: 1,
                                p: 0,
                                m: 0,
                              }}
                            >
                              <Typography
                                variant="subtitle1"
                                sx={{
                                  fontWeight: 600,
                                  fontSize: { xs: "0.875rem", sm: "1rem" },
                                  color: "#1a1a1a",
                                  flex: 1,
                                  px: 2,
                                  py: 0,
                                  m: 0,
                                }}
                              >
                                {faq.question}
                              </Typography>
                            </Box>
                          </AccordionSummary>
                          <AccordionDetails
                            sx={{
                              padding: {
                                xs: "12px 0 12px 44px",
                                sm: "20px 0 20px 56px",
                                md: "20px 0 20px 72px",
                              },
                              mx: 1,
                              my: 0,
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                color: "#666",
                                fontSize: { xs: "0.875rem", sm: "0.95rem" },
                                lineHeight: 1.7,
                              }}
                            >
                              {faq.answer}
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      </Box>
                    ))}
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box className="cta-section">
        <Container maxWidth="lg">
          <Box className="cta-content">
            <Box className="cta-icon">
              <CallEndIcon
                sx={{
                  fontSize: { xs: 40, sm: 50, md: 60 },
                  color: "#FF6B35",
                }}
              />
            </Box>
            <Typography
              className="cta-title"
              variant="h2"
              sx={{
                fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
                px: 2,
              }}
            >
              {cta?.title}
            </Typography>
            <Typography
              className="cta-subtitle"
              variant="h6"
              sx={{
                opacity: 0.9,
                mb: { xs: 3, sm: 4 },
                fontSize: { xs: "1rem", sm: "1.25rem" },
                px: 2,
              }}
            >
              {cta?.subtitle}
            </Typography>
            <Stack className="cta-buttons">
              <Button
                variant="contained"
                size="small"
                onClick={() => setOpenForm(true)}
                endIcon={<ArrowForwardIcon />}
                sx={{
                  px: { xs: 2, sm: 2.5, md: 3 },
                  py: { xs: 0.75, sm: 0.75 },
                  fontSize: { xs: "0.875rem", sm: "0.9375rem" },
                }}
              >
                Book Free Consultation
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={() => (window.location.href = `tel:${cta?.phone}`)}
                className="cta-button-secondary"
                sx={{
                  px: { xs: 3, sm: 4, md: 5 },
                  py: { xs: 1.25, sm: 1.5 },
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                }}
              >
                Call Now: {cta?.phone}
              </Button>
            </Stack>
            <Stack className="cta-features">
              {cta?.features?.map((feature, index) => (
                <Box key={index} className="cta-feature">
                  <CheckCircleIcon
                    sx={{
                      fontSize: { xs: 16, sm: 20 },
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{ fontSize: { xs: "0.875rem", sm: "0.9rem" } }}
                  >
                    {feature}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Box>
        </Container>
      </Box>

      <ChatButton />
      <ConsultationFormDialog
        open={openForm}
        onClose={() => setOpenForm(false)}
      />
    </div>
  );
};

export default Home;
